// eslint-disable-next-line import/prefer-default-export
export const scrollLayoutBodyToTop = () => {
  const el = document.getElementById('layout-body');
  if (el) el.scrollTop = 0;
};
